<template>
  <custom-dialog
    width="600px"
    :append-to-body="true"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="check-source-dialog"
  >
    <div class="dialog-body">
      <el-form
        ref="form"
        :inline="true"
        label-position="left"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item style="width: 100%;">
              <div class="img-container">
                <el-image
                  fit="contain"
                  class="img"
                  :src="img"
                  :preview-src-list="[img]"
                ></el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('dms_check_source_dialog.chuang_jian_shi_jian')">
              <div class="val">{{$momentLocal(info.gmtCreate) || '-'}}</div>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item :label="$t('dms_check_source_dialog.lu_xian_cao_hao')">
              <div class="val">{{getDicValue('sbr_slot', info.slotCode) || '-'}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('dms_check_source_dialog.gui_hua_mo_shi')">
              <div class="val">{{getDicValue('iot_tsl_map_mode', info.mapMode) || '-'}}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button
        type="primary"
        @click="onConfirm"
      >
        {{ $t('dms_check_source_dialog.que_ren') }}
      </el-button>
    </div>

  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
  },
  props: {
  },
  data() {
    return {
      form: {
        routeName: '',
      },
      img: '',
      info: {},
    };
  },
  computed: {
    rules() {
      return {
        routeName: {
          required: true,
          message: this.$t('Common.com_required')
        }
      };
    },

  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    },
    async getInfo() {
      const { oldHlcSlotId } = this.model.data;
      const url = `${apis.hlcSlotFindResouse}/${oldHlcSlotId}`;
      const { data } = await this.$getJSON(url);
      this.info = data;
      await this.getImg();
    },
    // 获取缩略图
    async getImg() {
      const info = this.info;
      const bizType = 'i';
      const bizId = info.mapId;
      const fileList = await this.$getFileList({
        bizId,
        bizType
      });
      const urlList = fileList.map(i => i.url);
      if (urlList.length) {
        this.img = urlList[0];
      }
    },
  },
  created() {
  },
  mounted() {
    this.getInfo();
  },
};
</script>

<style lang="scss">
.check-source-dialog {
  .val {
    font-size: 12px;
  }
  .el-form-item__content{
    width: 100% !important;
  }
  .img-container {
    width: 250px;
    height:250px;
    position: relative;
    margin: 0 auto;
    box-shadow: 0 0 0 1px #ccc;
    overflow: hidden;
    border-radius: 4px;
    .img {
      width: 100%;
      height: 100%;
      // position: absolute;
      // max-width: 100%;
      // max-height: 100%;
      // left: 0;
      // right: 0;
      // top: 0;
      // bottom: 0;
      // margin: auto;
    }
  }
}
</style>
